(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7599],{

/***/ 17292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/templates/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(34810);
// EXTERNAL MODULE: ../../libs/api/routes/useCases/queries/index.ts + 3 modules
var queries = __webpack_require__(95092);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/components/Badge/index.ts + 2 modules
var Badge = __webpack_require__(16154);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/matcha/components/VideoPlayer/index.ts + 2 modules
var VideoPlayer = __webpack_require__(41926);
// EXTERNAL MODULE: ../../libs/matcha/components/Elevation/index.ts + 2 modules
var Elevation = __webpack_require__(33606);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/UseCases/SinglePage/components/Hero/Video.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var Video = function Video(_ref) {
  var url = _ref.url;

  var _useState = (0,react.useState)(false),
      playing = _useState[0],
      setPlaying = _useState[1];

  var play = function play() {
    return setPlaying(true);
  };

  var stop = function stop() {
    return setPlaying(false);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledElevation, {
    elevation: 7,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(VideoPlayer/* default */.ZP, {
      url: url,
      playing: playing,
      onPause: stop,
      onPlay: play,
      children: [!playing && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoPlayer/* BigPlayButton */.sT, {
        ariaLabel: "Play Button",
        onClick: play
      }), !playing && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoPlayerCover, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Cover, {})
      })]
    })
  });
};

var StyledElevation = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Elevation/* default */.Z,  true ? {
  target: "euqwrij2"
} : 0)( true ? {
  name: "18k4vjr",
  styles: "padding-top:56px;max-width:800px"
} : 0);

var VideoPlayerCover = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(VideoPlayer/* Cover */.Y9,  true ? {
  target: "euqwrij1"
} : 0)( true ? {
  name: "bigtx2",
  styles: "background:none"
} : 0);

var Cover = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "euqwrij0"
} : 0)("background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[100];
}, ";width:100%;height:100%;opacity:0.2;" + ( true ? "" : 0));

/* harmony default export */ var Hero_Video = (Video);
;// CONCATENATED MODULE: ./src/views/UseCases/SinglePage/components/Hero/Hero.tsx


function Hero_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var backLink = {
  text: "Use Cases",
  href: "/use-cases"
};

var Hero_Hero = function Hero(_ref) {
  var useCase = _ref.useCase;
  var badges = useCase.useCase,
      title = useCase.title,
      description = useCase.description,
      videoURL = useCase.videoURL;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHeroRecipeBase, {
      variant: "2Col",
      copyVariant: "wide",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHeroCopy, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
          href: backLink.href,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButtonText, {
            tag: "span",
            iconStart: Common/* ChevronLeftIcon */.wy,
            children: backLink.text
          })
        }), badges && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BadgesWrapper, {
          children: badges.map(function (badge) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
              variant: "outlined",
              children: badge
            }, badge);
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h1",
            variant: "h1",
            children: title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pExtraLarge",
            children: description
          }), videoURL && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Video, {
            url: videoURL
          })]
        })]
      })
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e3xt0b44"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var StyledHeroRecipeBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Hero/* default */.ZP,  true ? {
  target: "e3xt0b43"
} : 0)(Hero/* Wrapper */.im, "{align-items:start;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("md");
}, "{padding-top:80px;padding-bottom:80px;}", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("lg");
}, "{grid-template-columns:minmax(472px, 60%);}", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("xl");
}, "{grid-template-columns:minmax(844px, 60%);}}" + ( true ? "" : 0));

var StyledHeroCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Hero/* Copy */.CK,  true ? {
  target: "e3xt0b42"
} : 0)("text-align:left;display:grid;justify-items:start;row-gap:24px;", function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.up("md");
}, "{row-gap:40px;}", function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.up("xxl");
}, "{row-gap:32px;}" + ( true ? "" : 0));

var StyledButtonText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "e3xt0b41"
} : 0)("margin-bottom:6px;", function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoints.up("sm");
}, "{margin-bottom:16px;}", function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpoints.up("md");
}, "{margin-bottom:0;}", function (_ref10) {
  var theme = _ref10.theme;
  return theme.breakpoints.up("xxl");
}, "{margin-bottom:8px;}" + ( true ? "" : 0));

var BadgesWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e3xt0b40"
} : 0)( true ? {
  name: "cl7urv",
  styles: "display:flex;flex-wrap:wrap;gap:8px"
} : 0);

/* harmony default export */ var components_Hero_Hero = (Hero_Hero);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/index.ts + 31 modules
var recipes_Card = __webpack_require__(74881);
;// CONCATENATED MODULE: ./src/views/UseCases/SinglePage/components/Card/Card.tsx


function Card_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var Card = function Card(_ref) {
  var authors = _ref.authors,
      roles = _ref.roles,
      title = _ref.title,
      description = _ref.description,
      experienceLevel = _ref.experienceLevel,
      industries = _ref.industries,
      slug = _ref.slug;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* default */.ZP, {
    href: (0,getAbsoluteUrl/* default */.Z)("/recipes/".concat(slug), pageConfig),
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCardBody, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Accessories */.v8, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* AccessoriesRow */.OW, {
          children: [roles === null || roles === void 0 ? void 0 : roles.map(function (role, key) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
              variant: "outlined",
              children: role
            }, role + key);
          }), industries === null || industries === void 0 ? void 0 : industries.map(function (industry, key) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
              variant: "outlined",
              children: industry
            }, industry + key);
          }), experienceLevel ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
            variant: "outlined",
            children: experienceLevel
          }) : null]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Headline */.s0, {
          tag: "h3",
          children: title
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Description */.dk, {
          children: description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Accessories */.v8, {
        children: authors === null || authors === void 0 ? void 0 : authors.map(function (_ref2, key) {
          var name = _ref2.name,
              headshot = _ref2.headshot;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* AccessoriesRow */.OW, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Author */.S3, {
              alt: name,
              size: "small",
              src: headshot.src
            }, name), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* Label */.__, {
              variant: "textTiny",
              children: ["Made by ", name]
            })]
          }, key);
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Action */.aU, {
        alignment: "left",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: "Use this recipe"
        })
      })]
    })
  });
};

var StyledCardBody = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Card/* Body */.uT,  true ? {
  target: "e1iv6iq50"
} : 0)( true ? {
  name: "1u7qp61",
  styles: "align-items:flex-start;grid-template-rows:min-content min-content 1fr"
} : 0);

/* harmony default export */ var Card_Card = (Card);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
;// CONCATENATED MODULE: ./src/views/UseCases/SinglePage/components/CardsGroup/CardsGroup.tsx


var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var CardsGroup = function CardsGroup(_ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, _objectSpread(_objectSpread({
    columns: 1,
    overrides: {
      lg: 3
    }
  }, rest), {}, {
    children: children
  }));
};

/* harmony default export */ var CardsGroup_CardsGroup = (CardsGroup);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
;// CONCATENATED MODULE: ./src/views/UseCases/SinglePage/components/CardsSection/CardsSection.tsx



var CardsSection_excluded = ["title", "isEmpty", "isLoading", "children"];

function CardsSection_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CardsSection_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CardsSection_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CardsSection_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function CardsSection_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var CardsSection = function CardsSection(_ref2) {
  var title = _ref2.title,
      isEmpty = _ref2.isEmpty,
      _ref2$isLoading = _ref2.isLoading,
      isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading,
      children = _ref2.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref2, CardsSection_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionBase, CardsSection_objectSpread(CardsSection_objectSpread({
    isEmpty: isEmpty,
    variant: "noCopy"
  }, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
      children: [title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopyTextBase, {
        isEmpty: isEmpty,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          children: title
        })
      }), children]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingOverlay, {
      "data-testid": "loading-overlay",
      "aria-busy": isLoading,
      isLoading: isLoading
    })]
  }));
};

var StyledCopyTextBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "et20q7r2"
} : 0)("margin-bottom:", function (_ref3) {
  var isEmpty = _ref3.isEmpty;
  return isEmpty ? "16px" : "40px";
}, ";" + ( true ? "" : 0));

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "et20q7r1"
} : 0)("position:relative;", function (_ref4) {
  var isEmpty = _ref4.isEmpty;
  return isEmpty && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(Section/* Wrapper */.im, "{padding-top:40px;padding-bottom:40px;}" + ( true ? "" : 0),  true ? "" : 0);
}, ";" + ( true ? "" : 0));

var _ref =  true ? {
  name: "o9ww1u",
  styles: "opacity:0.5"
} : 0;

var LoadingOverlay = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "et20q7r0"
} : 0)("opacity:0;background-color:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.neutrals.white[100];
}, ";position:absolute;top:0;left:0;bottom:0;right:0;width:100%;transition:opacity ease-in-out 0.3s;z-index:1;pointer-events:none;", function (_ref6) {
  var isLoading = _ref6.isLoading;
  return isLoading && _ref;
}, ";" + ( true ? "" : 0));

/* harmony default export */ var CardsSection_CardsSection = (CardsSection);
;// CONCATENATED MODULE: ./src/views/UseCases/SinglePage/components/RelatedRecipes/RelatedRecipes.tsx










var recipesLink = {
  text: "See all recipes",
  href: "/recipes"
};

var RelatedRecipes = function RelatedRecipes(_ref) {
  var recipes = _ref.recipes;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardsSection_CardsSection, {
    title: "Related recipes",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardsGroup_CardsGroup, {
      children: recipes.map(function (_ref2) {
        var authors = _ref2.authors,
            title = _ref2.title,
            description = _ref2.description,
            slug = _ref2.slug,
            roles = _ref2.roles,
            experienceLevel = _ref2.experienceLevel,
            industries = _ref2.industries;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card_Card, {
          authors: authors,
          title: title,
          description: description,
          roles: roles,
          experienceLevel: experienceLevel,
          industries: industries,
          slug: slug
        }, title);
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AllRecipesWrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
        tag: "a",
        href: (0,getAbsoluteUrl/* default */.Z)(recipesLink.href, pageConfig),
        iconEnd: Common/* ChevronRightIcon */.XC,
        children: recipesLink.text
      })
    })]
  });
};

var AllRecipesWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1wzr1zp0"
} : 0)("display:flex;padding-top:56px;justify-content:center;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{padding-top:80px;}" + ( true ? "" : 0));

/* harmony default export */ var RelatedRecipes_RelatedRecipes = (RelatedRecipes);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
;// CONCATENATED MODULE: ./src/views/UseCases/SinglePage/components/GettingStarted/GettingStarted.tsx


function GettingStarted_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var data = {
  heading: "Collect web and mobile analytics",
  description: "Collect data once with Segment and send it any tool you use.<br>No more tedious integrations."
};

var BaseGettingStarted = function BaseGettingStarted() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GettingStarted_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h2",
          children: data.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          dangerouslySetInnerHTML: {
            __html: data.description
          }
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Content, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "filled",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
          children: "Request a demo"
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})]
  });
};

/* harmony default export */ var GettingStarted = (BaseGettingStarted);
var GettingStarted_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1651vfm2"
} : 0)("overflow-y:auto;overflow-x:hidden;background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));
var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1651vfm1"
} : 0)("display:grid;justify-content:center;row-gap:40px;padding:40px 20px 0;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 80px 30px;}" + ( true ? "" : 0));
var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1651vfm0"
} : 0)( true ? {
  name: "k6fggx",
  styles: "width:100%;margin:0 auto;text-align:center"
} : 0);
;// CONCATENATED MODULE: ./src/views/UseCases/SinglePage/UseCaseSingle.tsx












var copy = {
  pageTitle: "Twilio Segment Use Cases",
  pageDescription: "Explore top use cases for Twilio Segment and the tools that power them. Implement Segment once, integrate 250+ tools with the flip of a switch, and unlock thousands of new uses cases for marketing, personalization, analytics, and more."
};

var UseCaseSingleView = function UseCaseSingleView(_ref) {
  var slug = _ref.slug;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();

  var _useUseCaseQuery = (0,queries/* useUseCaseQuery */.L4)({
    args: [slug]
  }),
      useCase = _useUseCaseQuery.data;

  var _useRelatedRecipesQue = (0,queries/* useRelatedRecipesQuery */.A8)({
    args: [slug]
  }),
      recipes = _useRelatedRecipesQue.data;

  if (!useCase || !recipes) throw new Error("Use Case or recipes is missing. Make sure it's preloaded");
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: copy.pageTitle,
      pageDescription: copy.pageDescription,
      bodyBackground: theme.palette.neutrals.white[100],
      themeColor: theme.palette.neutrals.white[100],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Hero_Hero, {
        useCase: useCase
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RelatedRecipes_RelatedRecipes, {
          recipes: recipes
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted, {})]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
    })
  });
};

/* harmony default export */ var UseCaseSingle = (UseCaseSingleView);

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e18gsu8r0"
} : 0)( true ? "" : 0);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var contexts_staticSiteBackend = __webpack_require__(86708);
;// CONCATENATED MODULE: ./src/pages/use-cases/[slug]/index.tsx





var UseCase = function UseCase(_ref) {
  var slug = _ref.slug;
  var staticSiteBackend = (0,react.useMemo)(function () {
    return (0,contexts_staticSiteBackend/* createStaticSiteBackend */.I4)();
  }, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(contexts_staticSiteBackend/* StaticSiteBackendProvider */.D1, {
    value: staticSiteBackend,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UseCaseSingle, {
      slug: slug
    })
  });
};

var __N_SSG = true;
/* harmony default export */ var _slug_ = (UseCase);

/***/ }),

/***/ 16201:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/[slug]",
      function () {
        return __webpack_require__(17292);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 45302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ rng; }
/* harmony export */ });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

/***/ }),

/***/ 20708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ unsafeStringify; }
/* harmony export */ });

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (stringify)));

/***/ }),

/***/ 20982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_browser_v4; }
});

;// CONCATENATED MODULE: ../../node_modules/uuid/dist/esm-browser/native.js
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ var esm_browser_native = ({
  randomUUID
});
// EXTERNAL MODULE: ../../node_modules/uuid/dist/esm-browser/rng.js
var rng = __webpack_require__(45302);
// EXTERNAL MODULE: ../../node_modules/uuid/dist/esm-browser/stringify.js
var stringify = __webpack_require__(20708);
;// CONCATENATED MODULE: ../../node_modules/uuid/dist/esm-browser/v4.js




function v4(options, buf, offset) {
  if (esm_browser_native.randomUUID && !buf && !options) {
    return esm_browser_native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng/* default */.Z)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return (0,stringify/* unsafeStringify */.S)(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,8943,7802,1382,4136,2073,8392,5735,2429,7303,8187,3996,442,4881,6818,2269,9774,2888,179], function() { return __webpack_exec__(16201); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);